module.exports = __webpack_public_path__ + "img/txt_info2.8052c0af.png";